import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    section: {
      marginTop: theme.spacing(3),
      maxWidth: '100%',
      flexBasis: '100%'
    },
    infoLayout:{
      textAlign: 'center',
      marginTop: theme.spacing(3),
      maxWidth: '100%',
      flexBasis: '100%',
      marginBottom: theme.spacing(3),
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    productsPaper: {
      padding: '20px',
      [theme.breakpoints.down('xs')]: {
        padding: '20px 0px'
      }
    },
    cash:{
      display: 'flex',
      justifyContent: 'center', 
      textAlign: 'center',
      [theme.breakpoints.up('md')]: {
        justifyContent: 'end'
      }
    },
    productsBox: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      overflow: 'auto'
    },
    redColor: {
      color: 'red'
    },
    button: {
      backgroundColor: '#D32F2F',
      marginTop: "3rem",
      [theme.breakpoints.down('sm')]: {
        display: 'block'
      }
    },
    productQty: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      border: 1,
      borderRadius: '50%',
      backgroundColor: 'red',
      color: 'white',
      width: '3rem',
      height: '3rem'
    },
    addressGrid: {
      width: '100%',
      '& .addressPaper': {
        padding: '0px 30px',
        height: "21rem",
        [theme.breakpoints.down('sm')]: {
          height:'100%'
        }
      },
      '& button': {
        margin: '1rem 0rem'
      }
    },
    orderInfoLabelGrid: {
      textAlign: 'center',
      [theme.breakpoints.up('md')]: {
        textAlign: 'left'
      }
    },
    orderInfoGrid: {
      textAlign: 'center',
      overflow: 'auto',
      [theme.breakpoints.up('md')]: {
        textAlign: 'right'
      }
    },
    orderInfoTitle:{
      textAlign: 'center',
      fontWeight: 'bold'
    },
    orderTitleGrid:{
      width: '100%'
    },
    productGrid: {
      width: '100%',
      '& .productPaper': {
        padding: '0px 30px',
        marginBottom: '2rem'
      },
      '& button': {
        margin: '1rem 0rem'
      }
    },
    productsContainer: {
      height: '100%',
      overflow: 'none',
      [theme.breakpoints.up('md')]: {
        height: '250px',
        overflow: 'scroll'
      }
    },
    cartItemsDesktop: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'block'
      }
    },
    cartItemsMobile: {
      display: 'none',
      [theme.breakpoints.down('sm')]: {
        display: 'block'
      },
      '& .MuiAccordionDetails-root': {
        display: 'block'
      }
    },
    buttonCancel: {
      justifyContent: 'flex-end',
      marginBottom: theme.spacing(5),
      marginTop: theme.spacing(5)
    },
    productImage: {
      width: '80px',
      height: '80px'
    },
    table: {
      minWidth: '700px',
      fontSize: '400pt',
      marginBottom: theme.spacing(3),
      borderLeft: '1px solid #d6dee1',
      borderRight: '1px solid #d6dee1'
    },
    orderInfo: {
      alignItems: 'flex-start',
      marginBottom: theme.spacing(3),
      marginTop: theme.spacing(5)
    },
    clientInfo: {
      alignItems: 'flex-start',
      marginBottom: theme.spacing(3),
      marginTop: theme.spacing(5),
    },
    primaryColor: {
      backgroundColor: '#D32F2F',
      color: 'white'
    }
  })
);
